/**
 * Intercepta o submit de formularios marcados com .js-confirmar e pede
 * confirmacao antes de seguir. A mensagem vem do atributo data-mensagem.
 *
 * Registrado na fase de captura de proposito: precisa rodar antes da protecao
 * de duplo envio, para que um cancelamento nao deixe o botao travado.
 */
export function iniciarConfirmacoes(escopo: ParentNode = document): void {
    escopo.querySelectorAll<HTMLFormElement>('form.js-confirmar').forEach(formulario => {
        formulario.addEventListener('submit', evento => {
            const mensagem = formulario.dataset.mensagem || 'Confirma a operação?';
            if (!window.confirm(mensagem)) {
                evento.preventDefault();
            }
        }, { capture: true });
    });
}
